import { render } from "./BillingAddressComponent.vue?vue&type=template&id=241b96d2"
import script from "./BillingAddressComponent.vue?vue&type=script&lang=js"
export * from "./BillingAddressComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__